import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const TitleSection = ({
  title,
  icon,
  onClick,
  actionIcon = "plus",
  actionLabel,
}: {
  title: string;
  icon: IconProp;
  onClick?: () => void;
  actionIcon?: IconProp;
  actionLabel?: string;
}) => {
  return (
    <div className="flex flex-col border-b border-grey-light mb-4">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <FontAwesomeIcon icon={icon} />
          <span className="text-lg font-oxaniumMedium">{title}</span>
        </div>
        {onClick && (
          <button
            onClick={onClick}
            aria-label={actionLabel}
            title={actionLabel}
            className="flex items-center gap-2 text-grey-medium hover:text-secondary"
          >
            {actionLabel && <span className="text-sm">{actionLabel}</span>}
            <FontAwesomeIcon icon={actionIcon} className="h-5 w-5" />
          </button>
        )}
      </div>
    </div>
  );
};
